function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg231Moldova(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.007,
    style: {
      fill: "#FFDA44"
    },
    width: 511.989,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.001,
    style: {
      fill: "#0052B4"
    },
    width: 170.663,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.336,
    style: {
      fill: "#D80027"
    },
    width: 170.663,
    height: 512
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9811"
    },
    d: "M322.781,215.063h-45.913c0-11.526-9.344-20.87-20.87-20.87c-11.526,0-20.87,9.344-20.87,20.87  h-45.913c0,11.347,9.885,20.548,21.232,20.548h-0.683c0,11.349,9.199,20.549,20.549,20.549c0,10.047,7.216,18.397,16.747,20.182  l-16.191,36.557c7.758,3.154,16.238,4.906,25.13,4.906c8.891,0,17.371-1.753,25.129-4.906l-16.191-36.557  c9.531-1.784,16.747-10.134,16.747-20.182c11.35,0,20.548-9.2,20.548-20.549h-0.685  C312.897,235.611,322.781,226.412,322.781,215.063z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "255.999,243.478 228.868,256 228.868,281.043 255.999,297.739 283.129,281.043 283.129,256   "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.863,
    y: 230.957,
    style: {
      fill: "#D80027"
    },
    width: 54.261,
    height: 25.043
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg231Moldova);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3QgeD0iMC4wMDciIHN0eWxlPSJmaWxsOiNGRkRBNDQ7IiB3aWR0aD0iNTExLjk4OSIgaGVpZ2h0PSI1MTIiLz4KPHJlY3QgeD0iMC4wMDEiIHN0eWxlPSJmaWxsOiMwMDUyQjQ7IiB3aWR0aD0iMTcwLjY2MyIgaGVpZ2h0PSI1MTIiLz4KPHJlY3QgeD0iMzQxLjMzNiIgc3R5bGU9ImZpbGw6I0Q4MDAyNzsiIHdpZHRoPSIxNzAuNjYzIiBoZWlnaHQ9IjUxMiIvPgo8cGF0aCBzdHlsZT0iZmlsbDojRkY5ODExOyIgZD0iTTMyMi43ODEsMjE1LjA2M2gtNDUuOTEzYzAtMTEuNTI2LTkuMzQ0LTIwLjg3LTIwLjg3LTIwLjg3Yy0xMS41MjYsMC0yMC44Nyw5LjM0NC0yMC44NywyMC44NyAgaC00NS45MTNjMCwxMS4zNDcsOS44ODUsMjAuNTQ4LDIxLjIzMiwyMC41NDhoLTAuNjgzYzAsMTEuMzQ5LDkuMTk5LDIwLjU0OSwyMC41NDksMjAuNTQ5YzAsMTAuMDQ3LDcuMjE2LDE4LjM5NywxNi43NDcsMjAuMTgyICBsLTE2LjE5MSwzNi41NTdjNy43NTgsMy4xNTQsMTYuMjM4LDQuOTA2LDI1LjEzLDQuOTA2YzguODkxLDAsMTcuMzcxLTEuNzUzLDI1LjEyOS00LjkwNmwtMTYuMTkxLTM2LjU1NyAgYzkuNTMxLTEuNzg0LDE2Ljc0Ny0xMC4xMzQsMTYuNzQ3LTIwLjE4MmMxMS4zNSwwLDIwLjU0OC05LjIsMjAuNTQ4LTIwLjU0OWgtMC42ODUgIEMzMTIuODk3LDIzNS42MTEsMzIyLjc4MSwyMjYuNDEyLDMyMi43ODEsMjE1LjA2M3oiLz4KPHBvbHlnb24gc3R5bGU9ImZpbGw6IzAwNTJCNDsiIHBvaW50cz0iMjU1Ljk5OSwyNDMuNDc4IDIyOC44NjgsMjU2IDIyOC44NjgsMjgxLjA0MyAyNTUuOTk5LDI5Ny43MzkgMjgzLjEyOSwyODEuMDQzIDI4My4xMjksMjU2ICAgIi8+CjxyZWN0IHg9IjIyOC44NjMiIHk9IjIzMC45NTciIHN0eWxlPSJmaWxsOiNEODAwMjc7IiB3aWR0aD0iNTQuMjYxIiBoZWlnaHQ9IjI1LjA0MyIvPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };